// const mock = {
//   mall: 'https://yapi.macrocura.com/mock/206',
// };

const service = {
  basename: '/',
  domain: 'https://api.macrocura.com',
  clinic: 'https://clinic.macrocura.com',
  business: 'https://user.macrocura.com',
  websocket: 'wss://api.macrocura.com',
  web: 'https://web.macrocura.com',
  apiVersion: 'v2',
};

const serviceDev = {
  basename: '/',
  domain: 'https://devapi.macrocura.com',
  clinic: 'http://devclinic.macrocura.com',
  business: 'https://devuser.macrocura.com',
  websocket: 'wss://devapi.macrocura.com',
  web: 'https://devweb.macrocura.com',
  apiVersion: 'v1',
};

const serviceTest = {
  basename: '/',
  domain: 'https://devapi.macrocura.com',
  clinic: 'http://devclinic.macrocura.com',
  business: 'https://devuser.macrocura.com',
  websocket: 'wss://devapi.macrocura.com',
  web: 'https://devweb.macrocura.com',
  apiVersion: 'v1',
};

const serviceQa = {
  basename: '/',
  domain: 'https://qaapi.macrocura.com',
  clinic: 'http://qaclinic.macrocura.com',
  business: 'https://qauser.macrocura.com',
  websocket: 'wss://qaapi.macrocura.com',
  web: 'https://qaweb.macrocura.com',
  apiVersion: 'v1',
};

const servicePrep = {
  basename: '/',
  domain: 'https://prepapi.macrocura.com',
  clinic: 'http://prepclinic.macrocura.com',
  business: 'https://prepuser.macrocura.com',
  websocket: 'wss://prepapi.macrocura.com',
  web: 'https://prepweb.macrocura.com',
  apiVersion: 'v1',
};

const serviceConfig = () => {
  let exportServer = service;
  const env = process.env.REACT_APP_SECRET_CODE;
  switch (env) {
    case 'production':
      exportServer = service;
      break;
    case 'development':
      exportServer = serviceDev;
      break;
    case 'test':
      exportServer = serviceTest;
      break;
    case 'qa':
      exportServer = serviceQa;
      break;
    case 'prep':
      exportServer = servicePrep;
      break;
    default:
      exportServer = serviceDev;
      break;
  }
  return exportServer;
};

export default {
  server: serviceConfig(),
};



// WEBPACK FOOTER //
// ./src/constants/EnvConfig.ts